import { howItWorks } from "../data/marketingContent";
import { SectionHeading } from "./SectionHeading";

export function HowItWorks() {
  return (
    <section className="section-wrap">
      <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
          <div>
            <SectionHeading
              eyebrow="How it works"
              title="From media to live screens in a controlled workflow."
              body="The flow is intentionally simple: organize content, create the playback source, pair screens, publish, and monitor."
            />
            <div className="mt-8 rounded-2xl border border-violet-200 bg-white p-5 shadow-sm">
              <img
                src="/brand/07_device_sizes_mark_transparent.svg"
                alt="PulsePanels device size mark"
                className="mx-auto h-auto max-h-48 w-full max-w-lg object-contain"
              />
            </div>
          </div>

          <ol className="work-steps">
            {howItWorks.map((step, index) => (
              <li key={step}>
                <span>{index + 1}</span>
                <p>{step}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
